import React from 'react'
import Img from 'react-image'
import Moment from 'react-moment'
import { Button, Confirm } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Typography } from '@material-ui/core'
import { getBillingScanDetail, confirmBillingScan } from 'ducks/qr'
import { Loading } from 'components'
import { QRScannerContainer, HeaderContainer, QRScannerBody, DocumentDataSection, ButtonSection } from './styled'
import { useParams } from 'react-router-dom'
import { billFormPath, BillformDetailPath } from 'routes'
import imgLogo from 'assets/images/DTGO_Logo_mini.png'

const BillingScan = (props) => {
  let { id, system } = useParams();

  const { qrBillingData } = props
  const [showConfirm, setShowConfirm] = React.useState(false)

  React.useEffect(() => {
    props.getBillingScanDetail(id,system=='buyer'?true:false)
  },[])

  const confirmSubmit = () => {
    setShowConfirm(false)
    props.confirmBillingScan(id,system=='buyer'?true:false,
      (success)=>{
        if(success){
          window.open(billFormPath,'_self')
        }else{
          //get detail after confirm
          props.getBillingScanDetail(id,system=='buyer'?true:false)
        }
      }
    )
  }

  return (
    <QRScannerContainer>
      <HeaderContainer>
        <div className='applicationName'>
          <Img src={imgLogo} style={{width:'2.5rem'}} />
          <div style={{width:'1rem'}}/>
          <Typography variant='h6' color='inherit'>
            {process.env.REACT_APP_NAME}
          </Typography>
        </div>
      </HeaderContainer>
      <QRScannerBody>
        <div className='rightContent'>
          <React.Fragment>
            {qrBillingData.id?
              qrBillingData.isCanScan ?
                qrBillingData.isScanned ? 
                  <span className='title' style={{ color: 'blue' }} >
                    เอกสารเลขที่ {qrBillingData.documentNumber} มีการ scan QR code แล้ว เมื่อวันที่ <Moment format='DD MMM YYYY - HH:mm:ss'>{qrBillingData.lastScannedDate}</Moment> หากต้องการ scan เพื่อรับเอกสารใหม่กรุณากด “Confirm”
                  </span> 
                  :
                  <span className='title'>กรุณายืนยันการรับเอกสารประกอบการวางบิลเลขที่ {qrBillingData.documentNumber}</span>
                :
                <span className='title' style={{ color: 'red' }}>สถานะ {qrBillingData.documentNumber} ไม่อยู่ในขั้นตอนการตรวจสอบของฝ่ายบัญชี (Account Approve Bill Form) กรุณาติดต่อ Requester</span>              
              :null
            }
            <DocumentDataSection style={{ flexDirection: 'column' }}>
              <div className='row' style={{ flex: 1 }}>
                <div className='title' style={{ marginRight: '10px', flex: 'none' }}>Document Number:</div>
                <a className='value' target='_blank' href={BillformDetailPath(qrBillingData.buyerId)}>{qrBillingData.documentNumber}</a>
              </div>
              <div className='row' style={{ flex: 1 }}>
                <div className='title' style={{ marginRight: '10px', flex: 'none' }}>Document Date:</div>
                <div className='value'><Moment format='DD MMM YYYY - HH:mm:ss'>{qrBillingData.billingDate}</Moment></div>
              </div>
            </DocumentDataSection>
            <DocumentDataSection>
              <span className='sectionTitle'>ข้อมูล Vendor</span>
              <div className='row'>
                <div className='title'>ชื่อบริษัท</div>
                <div className='value'>{qrBillingData.vendorName}</div>
              </div>
              <div className='row'>
                <div className='title'>ที่อยู่</div>
                <div className='value'>{qrBillingData.vendorAddress}</div>
              </div>
            </DocumentDataSection>
            <DocumentDataSection>
              <span className='sectionTitle'>ข้อมูลบริษัท</span>
              <div className='row'>
                <div className='title'>ชื่อบริษัท</div>
                <div className='value'>{qrBillingData.companyName}</div>
              </div>
              <div className='row'>
                <div className='title'>ที่อยู่</div>
                <div className='value'>{qrBillingData.companyAddress}</div>
              </div>
            </DocumentDataSection>
            <DocumentDataSection>
              <span className='sectionTitle'>หมายเหตุ</span>
              <div className='value'>
                กรณี Down Payment หากเอกสารประกอบการวางบิลไม่ถูกต้องหรือไม่ครบถ้วนต้อง "Confirm" ในระบบก่อนจากนั้นฝ่ายบัญชีเข้าระบบ EzProcure เพื่อตรวจสอบเอกสารและกด Revise ส่งเอกสารกลับให้ Vendor หรือโทรติดตามให้นำส่งเอกสารเพิ่มเติม
              </div>
            </DocumentDataSection>
            <ButtonSection>
              {qrBillingData.isCanScan?
                qrBillingData.isPermissionValid?
                <Button
                  content='Confirm'
                  color='blue'
                  onClick={()=>setShowConfirm(true)}
                />
                :
                <span className='invalidMessage'>คุณไม่มีสิทธิ์ scan QR code กรุณานำส่งเอกสารฝ่ายบัญชี เพื่อ scan QR code ยืนยันการรับเอกสาร</span>
              :null
              }
              <Button
                content='Close'
                color='red'
                onClick={()=>window.open('/','_self')}
              />
            </ButtonSection>
          </React.Fragment>
        </div>
      </QRScannerBody>
      <Loading />
      <Confirm
        size='tiny'
        open={showConfirm}
        onCancel={()=>setShowConfirm(false)}
        onConfirm={()=>confirmSubmit()}
      />
    </QRScannerContainer>
  )
}

const mapStateToProps = (state) => ({
  qrBillingData: state.qr.qrBillingData
})

const mapDispatchToProps = { 
  getBillingScanDetail, 
  confirmBillingScan
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingScan)